import { NgModule } from '@angular/core';
import { ResizableDirective } from './resizable.directive';
import { ResizableComponent } from './resizable.component';



@NgModule({
  declarations: [
    ResizableDirective,
    ResizableComponent
  ],
  exports: [
    ResizableComponent]
})
export class ResizableModule { }

